export type KeyMatch = {
  arguments: [string];
  key: string;
  operator: 'match';
};

export const keyMatch = function (key: string, argument: string): boolean {
  return key.toLowerCase().indexOf(argument.toLowerCase()) > -1;
};
